<template>
	<div id="logout">
		<IconBase class="icon" iconName="home" width="80" height="73"
				  viewBox="0 0 95 85"
				  v-on:onIconClicked="showLogoutDialogFlag = true">
			<IconLogin/>
		</IconBase>

		<div v-if="showLogoutDialogFlag" class="dialog-wrapper">
			<div class="arrow-up"></div>
			<div class="dialog">
				<div class="text">
					Möchten sie sich abmelden?
				</div>
				<div class="buttonGroup">
					<button class="button" v-on:click.stop.prevent="logout">
						Ja
					</button>
					<button class="button"
							v-on:click.stop.prevent="showLogoutDialogFlag = false">
						Nein
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import IconBase from '@/components/icons/IconBase.vue';
	import IconLogin from '@/components/icons/IconLogin.vue';

	export default {
		name: "Logout",
		components: {
			IconBase,
			IconLogin
		},
		methods: {
			logout() {
				localStorage.removeItem('token');
				this.$emit('logout');
				this.$router.push('/login');
				this.showLogoutDialogFlag = false;
			}
		},
		data() {
			return {
				showLogoutDialogFlag: false
			}
		}
	}
</script>

<style scoped>
	#logout {
		position: relative;
	}

	.dialog-wrapper {
		position: absolute;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: space-around;
		left: -58px;
		z-index: 99;

	}

	.arrow-up {
		width: 0;
		height: 0;
		border-left: 12px solid transparent;
		border-right: 12px solid transparent;

		border-bottom: 20px solid black;
	}

	.dialog {
		width: 200px;
		height: 150px;
		background-color: black;
		display: flex;
		flex-flow: column;
		align-items: center;
	}

	.text {
		color: white;
		font-size: 20px;
		padding: 20px;
	}

	.buttonGroup {
		margin-top: -28px;
	}
</style>